import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';

import { TinDocumentType } from '../types';

export const getTinDocumentTypes = ({
  countryId,
}: {
  countryId: string;
}): Promise<TinDocumentType[]> => {
  if (countryId) {
    return axios
      .get(PAYMENTS_BACKEND_URL + 'tin-document-types?country=' + countryId)
      .then((response: any) => {
        return parseTinDocumentTypes(response._embedded?.tin_document_types);
      });
  }
  return new Promise((resolve) => {
    resolve([]);
  });
};

const parseTinDocumentTypes = (tinDocumentTypes: any): TinDocumentType[] => {
  if (tinDocumentTypes && tinDocumentTypes.length > 0) {
    return tinDocumentTypes.map(function (tinDocumentType: any) {
      return {
        id: tinDocumentType.documentType,
        country: tinDocumentType.country,
        name: tinDocumentType.description,
      };
    });
  }
  return [];
};
